<base-index-page
  [config]="baseIndexPageConfig"
  [service]="projectsService"
  [idKey]="'checklistGroupId'"
  [subSectionSettings]="'deleteSettingsChecklistGroup'"
></base-index-page>
